module.exports = __webpack_public_path__ + "static/media/07C.b3b6eed9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/07C.png
// module id = 282
// module chunks = 0